// Name to show for a user: username, else "givenName familyName", else email.
// Never returns null/undefined.
export default function getDisplayName(user) {
  const username = user?.username?.trim();
  if (username) return username;

  const fullName = [user?.givenName, user?.familyName]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ');
  if (fullName) return fullName;

  return user?.email?.trim() || '';
}
